import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setPageLoadingTrue, setPageLoadingFalse } from "../appSlice";
import { get, post } from "../../../components/Utils/CallApi";
import { setError } from "../appSlice";

export const fetchLaws = createAsyncThunk(
  "laws/fetchLaws",
  async (
    { companyId, page, limit, categoryId },
    { dispatch, rejectWithValue }
  ) => {
    try {
      dispatch(setPageLoadingTrue());
      let params = `companyId=${companyId}&sectionType=laws&page=${page}&limit=${limit}`;
      if (categoryId) {
        params += `&categoryId=${categoryId}`;
      }
      const response = await get("sections/data/list", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const saveLaw = createAsyncThunk(
  "laws/saveLaws",
  async (
    { payload, sectionId, files },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      dispatch(setPageLoadingTrue());
      const state = getState();
      const response = await post(
        "sections/data/save",
        payload,
        state.app,
        sectionId,
        files
      );

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.data;
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const updateLaw = createAsyncThunk(
  "laws/updateLaw",
  async (law, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      //   // Simulated API call to update a law
      //   const response = { status: "success", data: law };
      //   if (response.status === "failure") {
      //     return rejectWithValue(response.result);
      //   }
      //   dispatch(editLaw(response.data));
      //   return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const getLaw = createAsyncThunk(
  "laws/getLaw",
  async ({ id }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setPageLoadingTrue());
      const params = `id=${id}&sectionType=laws`;
      const response = await get("sections/data/get", params);

      if (response.status === "failure") {
        dispatch(setError(response.result));
        return rejectWithValue(response.result);
      }

      return response.result || [];
    } catch (error) {
      dispatch(setError(error.message));
      return rejectWithValue(error.message);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  }
);

export const addLaw = (law) => ({
  type: "laws/addLaw",
  payload: law,
});

export const editLaw = (updatedLaw) => ({
  type: "laws/editLaw",
  payload: updatedLaw,
});

const lawsSlice = createSlice({
  name: "laws",
  initialState: {
    lawsList: [],
    loading: false,
    error: null,
  },
  reducers: {
    addLaw: (state, action) => {
      if (action.payload) {
        state.lawsList.push(action.payload);
      }
    },
    editLaw: (state, action) => {
      const index = state.lawsList.findIndex(
        (law) => law.id === action.payload.id
      );
      if (index !== -1) {
        state.lawsList[index] = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLaws.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLaws.fulfilled, (state, action) => {
        state.loading = false;
        state.lawsList = action.payload;
      })
      .addCase(fetchLaws.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default lawsSlice.reducer;
